"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};
//# sourceMappingURL=alert.constants.js.map